"use client";

import { useRouter } from "next/navigation";
import Button from "@/components/Button";
import { formatDateToLongLabel } from "@/lib/utils";

interface CanceledSubscriptionCardProps {
  validUntil: string;
  allowParentTakeover?: boolean;
}

export default function CanceledSubscriptionCard({
  validUntil,
  allowParentTakeover = true
}: CanceledSubscriptionCardProps) {
  const router = useRouter();
  const formattedDate = formatDateToLongLabel(new Date(validUntil));

  return (
    <div className="bg-white shadow border border-gray-200 rounded-xl p-4">
      <p className="text-gray-700 mb-3 text-center">
        Je hebt je abonnement stopgezet. Wil je na {formattedDate} toegang
        houden tot alle uitleg van WisWiz?
      </p>

      <div className="flex flex-col items-center gap-2">
        <Button
          onClick={() => router.push("/checkout")}
          className="!py-2 !px-4 !text-sm"
        >
          Verleng abonnement
        </Button>
        {allowParentTakeover && (
          <button
            onClick={() => router.push("/account?invite=true")}
            className="text-sm text-gray-600 hover:text-gray-800 transition-colors"
          >
            of <span className="underline">laat je ouder overnemen</span>
          </button>
        )}
      </div>
    </div>
  );
}
